const COMPONENT_NAME = "Checkbox";
export {
  COMPONENT_NAME
};
